import { defineMessages } from 'react-intl'

export const newDomainModalMessages = defineMessages({
  ctaBtn: {
    id: 'newDomain.ctaBtn',
    description: 'CTA button on modal allowing to add nested Group/Domain',
    defaultMessage: 'Save',
  },
  title: {
    id: 'newDomain.title',
    description: 'A title of modal allowing to add nested Group/Domain',
    defaultMessage: 'Add New Group to {domainName}',
  },
  input: {
    id: 'newDomain.input',
    description: "Input's placeholder for the name of new nested Group/Domain",
    defaultMessage: 'Group Name',
  },
  alreadyExists: {
    id: 'newDomain.alreadyExists',
    description:
      'Error message for already existing name for new nested Group/Domain',
    defaultMessage: 'Group Name should be unique',
  },
  successTitle: {
    id: 'newDomain.successTitle',
    description:
      'Title of modal in case if group/domain was created successfully',
    defaultMessage: 'Group was successfully created in {domainName}',
  },
  successText: {
    id: 'newDomain.successText',
    description:
      'Text of modal in case if group/domain was created successfully',
    defaultMessage: 'Use navigation dropdown to access it.',
  },
})
